<div id="create-new-invoice-wrap" class="createNew-invoice revealed" *ngIf="!prevInvoice">
  <h2 i18n="@@invoices.create_new_invoice">Create New Invoice</h2>

  <a (click)="closeModel()" href="javascript:void(0)" id="closeNew" class="close-circle d-flex">
    <svg version="1.1" x="0px" y="0px" width="14" height="14" viewBox="0 0 14 14">
      <path class="icon-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"></path>
    </svg>
  </a>
  <!--Star create new invoice form-->

  <form class="createNew-invoice__form" [formGroup]="invoiceForm" (ngSubmit)="saveInvoice()">
    <div class="createNew-invoice__wrap">
      <section class="createNew-invoice__content">
        <h3 class="white"><span i18n="@@invoices.invoice_details">Invoice details</span></h3>

        <div class="invoiceDetails">

          <fieldset class="inv-to">
            <label i18n="@@invoices.invoices_to">Invoice to</label>
            <div class="taxSection">
              <span class="name font-weight-bold">{{ invoiceDetail.client.full_name }}</span>
            </div>
          </fieldset>

          <fieldset class="inv-to">
            <label i18n="@@invoices.include_tax" for="include-tax">VAT</label>
            <div class="taxSection">
              <span class="name font-weight-bold">{{ selectedType }}</span>
            </div>
          </fieldset>

          <fieldset class="inv-to" [ngClass]="{'has-error': submitted && invoiceForm.controls.invoice_date.errors && invoiceForm.controls.invoice_date.errors.required}">
            <label i18n="@@invoices.invoice_date">Invoice Date</label>
            <div class="date-input-wrap">
              <input type="text" date-dropper formControlName="invoice_date" data-large-default="true" class="date-input datedropper-init" data-theme="teamup" data-dd-format="d/m/Y" id="invoiceDate" />
            </div>
            <span class="field-error" i18n="@@error.required">* Required</span>
          </fieldset>

          <fieldset class="inv-to" [ngClass]="{'has-error': submitted && invoiceForm.controls.invoice_number.errors }">
            <label i18n="@@invoices.invoice_number">Invoice Number</label>
            <input type="number" class="project-title" formControlName="invoice_number" i18n-placeholder="@@invoices.invoice_number" placeholder="Invoice Number" />
            <span class="field-error" *ngIf="invoiceForm.controls.invoice_number.errors && invoiceForm.controls.invoice_number.errors?.serverError">{{
              invoiceForm.controls.invoice_number.errors?.serverError }}</span>
            <span class="field-error" *ngIf="invoiceForm.controls.invoice_number.errors && !invoiceForm.controls.invoice_number.errors?.serverError" i18n="@@error.required">* Required</span>
          </fieldset>
        </div>

        <h3 class="white"><span i18n="@@invoices.items">Items</span></h3>

        <div class="createNew-invoice__list">
          <div class="head-section">
            <div class="item-name" i18n="@@invoices.item_name">Item name</div>
            <div class="item-qty" i18n="@@common.qty">Qty</div>
            <div class="item-rate" i18n="@@invoices.rate">Rate</div>
            <div class="item-cost" i18n="@@invoices.amount">Amount</div>
            <div class="item-edit"></div>
          </div>
          <ng-container *ngFor="let deliverable of deliverables?.controls; index as $index">
            <div class="body-section" [formGroup]="deliverable">
              <div class="item-name">{{ deliverable.controls.title.value }}</div>
              <div class="item-qty">
                <div class="item-counter">

                  <button class="min-count" type="button" (click)="changeQuantity(deliverable,'minus')">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                      <g>
                        <g>
                          <rect y="236" width="512" height="40" />
                        </g>
                      </g>
                    </svg>
                  </button>
                  <input type="number" (ngModelChange)="changeInputQuantity(deliverable)" (change)="changeInputQuantityIfValueNullOrZero(deliverable)" name="quantity" class="qty_input" min="0" formControlName="quantity" [ngClass]="{'error': deliverable.get('quantity').invalid }" placeholder="0" autocomplete="off">

                  <button class="pls-count" type="button" (click)="changeQuantity(deliverable,'plus')">
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                      <g>
                        <g>
                          <polygon points="276,236 276,0 236,0 236,236 0,236 0,276 236,276 236,512 276,512 276,276 512,276 512,236" />
                        </g>
                      </g>
                    </svg>
                  </button>
                </div>
              </div>
              <div class="item-rate">
				<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
                <span class="num">{{ deliverable.controls.rate.value | number:'.2' }}</span>
              </div>
              <div class="item-cost">
				<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
                <span class="num">{{ getItemSubTotal(deliverable.value) | number:'.2' }}</span>
              </div>
              <div class="item-edit">
                <!-- Delete Deliverable -->
                <a href="javascript:void(0)" class="delete" (click)='removeDeliverable($index)'>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
                    <g fill="none" fill-rule="evenodd">
                      <g fill="#FB4575">
                        <path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)" />
                      </g>
                    </g>
                  </svg>
                </a>
              </div>
            </div>
          </ng-container>
        </div>

        <invoice-deliverable-form [form]="deliverableForm" [formType]="''" (onSubmit)="addDeliverable($event)" [formId]="'create-deliverable'" [deliverableList]="productAndServices" [showAddNewItem]="false"></invoice-deliverable-form>
      </section>

      <aside class="createNew-invoice__side">
        <div class="top-total">
          <span class="title" i18n="@@invoices.invoice_total">TOTAL AMOUNT</span>
          <div class="price">
			<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
            <span class="num">{{ (invoiceTotal > 0) ? (invoiceTotal | shortNumber) : (invoiceTotal | number:'.2') }}</span>
          </div>
        </div>

        <div class="sub-total">
          <div class="left" i18n="@@invoices.sub_total">Sub total</div>
          <div class="right">
			<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
            <span class="num">{{ (subTotalDeliverableCost > 0) ? (subTotalDeliverableCost | shortNumber) : (subTotalDeliverableCost | number:'.2') }}</span>
          </div>
        </div>

		<div class="sub-total" *ngIf="taxAmount">
			<div class="left">
				<ng-container i18n="@@invoices.tax">VAT({{invoiceDetail.tax_percent }}%)</ng-container>
			</div>
			<div class="right">
				<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
				<span class="num">{{ taxAmount | number:'.2'  }}</span>
			</div>
		</div>

		<div class="sub-total" *ngIf="invoiceDeliveryFeeAmount">
			<div class="left">
				<ng-container i18n="@@invoices.delivery_fees">Delivery Fees</ng-container>
			</div>
			<div class="right">
			  <span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
			  <span class="num">{{ invoiceDeliveryFeeAmount | number:'.2'  }}</span>
			</div>
		</div>

        <div class="dashed-border"></div>
		<div class="sub-total" *ngIf="invoiceDiscountAmount != null">
			<div class="left">
				<ng-container i18n="@@invoices.discount">Discount</ng-container>
				<ng-container *ngIf="discountType == 'percentage'; else elseDiscountType">
				({{invoiceDetail.discount}}%)
				</ng-container>
				<ng-template #elseDiscountType>
				(<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span> {{ invoiceDetail.discount | number:'.2' }})
				</ng-template>
			</div>
			<div class="right">
				<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
				<span class="num">{{ (invoiceDiscountAmount > 0) ? (invoiceDiscountAmount | shortNumber) : (invoiceDiscountAmount | number:'.2') }}</span>
			</div>
		</div>

		<div class="dashed-border" *ngIf="invoiceDiscountAmount != null"></div>
		
        <div class="sub-total">
          <div class="left"><b i18n="@@invoices.preview.total_amount_due">Total amount due</b></div>
          <div class="right">
			<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
            <span class="num">{{ (invoiceTotal > 0) ? (invoiceTotal | shortNumber) : (invoiceTotal | number:'.2') }}</span>
          </div>
        </div>
      </aside>

    </div>
  </form>
  <!--End create new invoice form-->

  <div class="createNew-invoice__footer">
    <div class="social-wrapper">
      <span i18n="@@invoices.send_invoice_via">Send invoice via</span>
      <!-- Save and share link -->
      <a href="javascript:void(0)" (click)="saveAndShareLink()">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
          <g fill="none" fill-rule="evenodd">
            <g fill="#B1B1B1" stroke="#B1B1B1" stroke-width=".5">
              <path d="M5.276 8.843c.35.349.376.896.08 1.275l-.08.09-1.369 1.365c-1.592 1.588-1.505 4.227.262 5.7 1.51 1.258 3.755 1.07 5.206-.239l.153-.144 1.224-1.222c.378-.377.99-.377 1.37 0 .348.349.375.896.08 1.275l-.08.09-1.37 1.365c-2.443 2.435-6.536 2.245-8.719-.573-1.751-2.261-1.458-5.481.47-7.572l.179-.187 1.225-1.223c.379-.376.992-.376 1.37 0zm7.808-.961c.347.346.373.89.08 1.268l-.08.09-3.844 3.844c-.187.187-.433.282-.68.282-.245 0-.491-.095-.679-.282-.347-.347-.373-.891-.08-1.268l.08-.09 3.844-3.844c.376-.376.983-.376 1.359 0zm-3.056-5.183c2.097-2.101 5.48-2.481 7.817-.653 2.8 2.189 2.983 6.268.55 8.706h0l-1.367 1.369c-.377.378-.988.378-1.366 0-.378-.378-.378-.992 0-1.37h0l1.366-1.37c1.59-1.592 1.504-4.24-.26-5.717-1.564-1.31-3.91-1.06-5.351.383h0l-1.224 1.225c-.376.379-.99.379-1.366 0-.378-.377-.382-.987.17-1.54h0z" transform="translate(-281 -921) translate(0 849) translate(264 55) translate(17 17)" />
            </g>
          </g>
        </svg>
      </a>
      <!-- Save and Email-->
      <a href="javascript:void(0)" (click)="saveAndEmail()" *ngIf="invoiceDetail?.client && invoiceDetail?.client.email">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18">
          <g fill="none" fill-rule="evenodd">
            <g fill="#1C6AB6">
              <path d="M17.82 17.144H3.146c-.578 0-1.048-.465-1.048-1.038V5.992l7.757 5.757c.186.14.408.208.629.208.22 0 .442-.069.629-.208l7.757-5.757v10.114c0 .573-.47 1.038-1.048 1.038zm-.699-12.449l-6.638 4.928-6.639-4.928h13.277zm.7-2.074H3.145C1.41 2.62 0 4.017 0 5.733v10.373c0 1.716 1.411 3.112 3.145 3.112H17.82c1.734 0 3.145-1.396 3.145-3.112V5.733c0-1.716-1.411-3.112-3.145-3.112z" transform="translate(-365 -923) translate(0 849) translate(348 55) translate(17 17)" />
            </g>
          </g>
        </svg>
      </a>
      <!-- Save as PDF -->
      <a href="javascript:void(0)" (click)="saveAsPdf()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21">
          <g fill="none" fill-rule="evenodd">
            <path fill="#1C6AB6" d="M9.721 3.905c-.007 0-.021.001-.044.01-.103.033-.208.188-.28.412-.22.672-.133 1.802.323 2.843.145-.493.232-.908.255-1.223.111-1.536-.137-1.933-.217-2.017-.022-.025-.03-.025-.037-.025m.244 5.293c-.319.783-.707 1.63-1.128 2.462a18.051 18.051 0 0 1 2.54-.431l.213-.02a58.897 58.897 0 0 1-1.238-1.524l-.387-.487m3.664 2.852c.688.638 1.266.996 1.754 1.085.11.02.22.031.325.031.36 0 .598-.123.664-.239.013-.02.03-.05-.011-.121-.154-.265-.9-.701-2.732-.756m-6.743 1.254c-.637.308-1.163.663-1.572 1.063-.804.785-.856 1.278-.812 1.388.014.032.07.039.114.039.136 0 .319-.069.5-.186.397-.26 1.053-1.121 1.77-2.304m-2.27 3.402c-.446 0-.804-.227-.959-.607-.257-.632.114-1.501 1.02-2.386.708-.692 1.698-1.261 2.943-1.695a32.176 32.176 0 0 0 1.699-3.67c-.946-1.471-1.121-3.289-.79-4.304.214-.657.585-.904.858-.995a.965.965 0 0 1 1.04.259c.409.439.559 1.323.458 2.704-.039.55-.222 1.289-.544 2.2l.043.052c.214.263.443.551.684.854.512.646 1.087 1.371 1.673 2.021.173-.005.339-.007.5-.007 2.068 0 3.457.432 3.91 1.218.194.334.198.711.012 1.034-.252.435-.795.695-1.455.695-.16 0-.324-.015-.49-.047-.832-.153-1.744-.778-2.861-1.963-.286.016-.585.038-.892.068-.658.064-1.93.23-3.215.634-.555 1-1.746 3.02-2.634 3.6-.337.22-.682.335-1 .335">
            </path>
            <path stroke="#1C6AB6" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M18.86 19.549l-17.77.086L1 1.02 18.8 1z"></path>
          </g>
        </svg>
      </a>
      <!-- Save and WhatsApp -->
      <a href="javascript:void(0)" (click)="saveAndWhatsapp()">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="2489" height="2500" viewBox="0 0 1219.547 1225.016">
          <path fill="#E0E0E0" d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z" />
          <linearGradient id="a" gradientUnits="userSpaceOnUse" x1="609.77" y1="1190.114" x2="609.77" y2="21.084">
            <stop offset="0" stop-color="#20b038" />
            <stop offset="1" stop-color="#60d66a" />
          </linearGradient>
          <path fill="url(#a)" d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z" />
          <image overflow="visible" opacity=".08" width="682" height="639" xlink:href="FCC0802E2AF8A915.png" transform="translate(270.984 291.372)" />
          <path fill-rule="evenodd" clip-rule="evenodd" fill="#FFF" d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z" />
          <path fill="#FFF" d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z" />
        </svg>
      </a>

    </div>
    <div class="preview-btn" *ngIf="!prevInvoice">
      <a href="javascript:void(0)" class="tu-btn icon-left blue" (click)="openPreviewModal()" i18n-title="@@title.preview_invoice">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22">
          <g fill="none" fill-rule="evenodd">
            <g fill="#FFF">
              <path d="M10.483 12.511c-.867 0-1.572-.714-1.572-1.59 0-.878.705-1.592 1.572-1.592.867 0 1.572.714 1.572 1.591s-.705 1.591-1.572 1.591m0-5.303c-2.023 0-3.67 1.665-3.67 3.712s1.647 3.713 3.67 3.713c2.023 0 3.669-1.666 3.669-3.713s-1.646-3.712-3.67-3.712m.231 9.013c-4.514.106-7.458-3.8-8.435-5.305 1.075-1.703 3.784-5.188 7.975-5.297 4.496-.115 7.458 3.801 8.435 5.306-1.075 1.703-3.785 5.188-7.975 5.296m10.114-5.828C20.158 9.213 16.464 3.3 10.2 3.499 4.405 3.648 1.034 8.813.14 10.393c-.186.326-.186.728 0 1.055.659 1.164 4.223 6.897 10.369 6.897l.258-.003c5.794-.15 9.165-5.315 10.06-6.894.185-.327.185-.729 0-1.055" transform="translate(-1217 -921) translate(0 849) translate(1180 55) translate(37 17)" />
            </g>
          </g>
        </svg>
        <span i18n="@@title.preview_invoice">Preview</span>
      </a>

    </div>
    <div class="preview-btn" *ngIf="prevInvoice">
      <a href="javascript:void(0)" class="tu-btn blue" i18n-title="@@common.back" (click)="closeModel()">
        <span i18n="@@common.back">Back</span>
      </a>

    </div>
  </div>

</div>


<!-- Preview Invoice -->

<div class="prev-invoice" style="display: block;" *ngIf="prevInvoice">
	<div class="prev-invoice__web">
	   <a (click)="closeModel()" href="javascript:void(0)" class="simplified-invoice__backBtn closePrvinvoice">
			<svg class="simplified-preview__backIcon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
				<path d="M19 11H7.135l3.633-4.36a1 1 0 1 0-1.536-1.28l-5 6c-.039.047-.059.102-.088.154-.024.042-.053.078-.071.124a.985.985 0 0 0-.072.358L4 12l.001.004c0 .122.027.243.072.358.018.046.047.082.071.124.029.052.049.107.088.154l5 6a.999.999 0 1 0 1.536-1.28L7.135 13H19a1 1 0 0 0 0-2" fill="#030E18" fill-rule="evenodd"/>
			</svg>
			<svg class="simplified-preview__closeIcon" width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
				<path d="m17.885 16 5.724-5.724a1.332 1.332 0 0 0 0-1.885 1.332 1.332 0 0 0-1.885 0L16 14.115 10.276 8.39a1.332 1.332 0 0 0-1.885 0 1.332 1.332 0 0 0 0 1.885L14.115 16 8.39 21.724A1.332 1.332 0 0 0 9.333 24c.342 0 .683-.13.943-.39L16 17.884l5.724 5.724a1.33 1.33 0 0 0 1.885 0 1.332 1.332 0 0 0 0-1.885L17.885 16z" fill="#030E18" fill-rule="evenodd"/>
			</svg>
			<span i18n="@@invoices.back_to_create_new_invoice">Back to create new invoice</span>
		</a>
		<ul>
			<li>
				<a class="invoice-screen-type ist-1" href="javascript:void();" (click)="setInvoiceWidth('mobile')" >
					<svg width="14" height="20" viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg">
						<path d="m7.71 14.29-.15-.12a.76.76 0 0 0-.18-.09L7.2 14a1 1 0 0 0-.91.27 1.15 1.15 0 0 0-.21.33 1 1 0 0 0 1.3 1.31c.12-.058.23-.132.33-.22a1 1 0 0 0 .21-1.09 1 1 0 0 0-.21-.31zM11 0H3a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3zm1 17a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v14z" fill="#B1B1B1" fill-rule="nonzero"/>
					</svg>
					Mobile
				</a>
			</li>
			<li>
				<a class="invoice-screen-type ist-2" (click)="setInvoiceWidth('pdf')" href="javascript:void();">
					<svg width="17" height="20" viewBox="0 0 17 20" xmlns="http://www.w3.org/2000/svg">
						<g fill="#B1B1B1" fill-rule="nonzero">
							<path d="M16.364 6.31a1.19 1.19 0 0 0-.055-.246v-.082a.973.973 0 0 0-.173-.255L10.682.273A.973.973 0 0 0 10.427.1h-.082l-.29-.1H2.727A2.727 2.727 0 0 0 0 2.727v14.546A2.727 2.727 0 0 0 2.727 20h10.91a2.727 2.727 0 0 0 2.727-2.727V6.309zM10.909 3.1l2.355 2.355h-2.355V3.1zm3.636 14.173a.91.91 0 0 1-.909.909H2.727a.91.91 0 0 1-.909-.91V2.728a.91.91 0 0 1 .91-.909H9.09v4.546c0 .502.407.909.909.909h4.545v10z"/>
							<path d="M12.467 12.088c-.545-.536-2.1-.388-2.876-.29-.769-.469-1.282-1.116-1.644-2.067.174-.719.451-1.812.241-2.5C8 6.061 6.5 6.178 6.285 6.968c-.196.719-.018 1.718.313 2.995-.447 1.067-1.112 2.5-1.581 3.321-.894.46-2.1 1.17-2.278 2.063-.148.705 1.16 2.464 3.399-1.393 1-.33 2.09-.737 3.055-.897.844.455 1.832.758 2.493.758 1.139 0 1.25-1.258.781-1.727zm-8.84 3.573c.235-.625 1.129-1.346 1.4-1.597-.875 1.383-1.4 1.629-1.4 1.597zm3.746-6.697c-.182-.614-.178-1.8-.074-1.8.306 0 .277 1.416.074 1.8zm-.064 1.8c.364.662.828 1.193 1.318 1.557-.91.189-1.703.575-2.4.843.425-.742.789-1.624 1.082-2.4zm4.777 2.246s-.222.25-1.659-.325c1.561-.108 1.82.225 1.66.325z"/>
						</g>
					</svg>
					PDF
				</a>
			</li>
			<li>
				<a class="invoice-screen-type ist-3 active" (click)="setInvoiceWidth('web')" href="javascript:void();">
					<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
						<path d="M8.182 3.636a.91.91 0 1 0 0 1.819.91.91 0 0 0 0-1.819zm-3.637 0a.91.91 0 1 0 0 1.819.91.91 0 0 0 0-1.819zm7.273 0a.91.91 0 1 0 0 1.819.91.91 0 0 0 0-1.819zM17.273 0H2.727A2.727 2.727 0 0 0 0 2.727v14.546A2.727 2.727 0 0 0 2.727 20h14.546A2.727 2.727 0 0 0 20 17.273V2.727A2.727 2.727 0 0 0 17.273 0zm.909 17.273a.91.91 0 0 1-.91.909H2.728a.91.91 0 0 1-.909-.91V9.092h16.364v8.182zm0-10H1.818V2.727a.91.91 0 0 1 .91-.909h14.545a.91.91 0 0 1 .909.91v4.545z" fill="#B1B1B1" fill-rule="nonzero"/>
					</svg>
					Web
				</a>
			</li>
		</ul>
   	</div>
   	<div class="page-size">
		<div id="invoice-to-pdf-loading" style="display: none;" >
			<div class="prev-invoice__loading" >
				<div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
			</div>
		</div>

		<!-- <div style="display: none;" class="simplified-preview__pdf" id="left-section-pdf" >
			<pdf-view-invoice
				[invoiceDetail]="invoiceDetail"
				[qrCodeBase64]="qrCodeBase64"
				[additionalInfo]="defaultAdditionalInfo"
				[discount]="invoiceForm.controls.discount.value"
				[paymentInfo]="defaultPaymentInfo"
			></pdf-view-invoice>
		</div> -->
	
		<div id="left-section-invoice" class="prev-invoice__leftSection prev-invoice__leftSection--nopadding simplified-invoice__invoice">
			<div class="simplified-invoice__header">
				<ng-container *ngIf="taxInvoice">
					<div class="simplified-invoice__title">
						<ng-container *ngIf="(userInfo.country_id == COUNTRIES.SAUDI_ARABIA); else outSideSaudi">
							<p i18n="@@invoices.simplified_tax_invoice">Simplified Tax Invoice</p>
						</ng-container>
						<ng-template #outSideSaudi>
							<p i18n="@@invoices.tax_invoice">Tax Invoice</p>
						</ng-template>	
					</div>
					<div class="wrapper no-wrapper">
						<hr class="hr-row simplified-invoice__line">
					</div>
				</ng-container>
				
			</div>

			<div class="wrapper simplified-invoice__headerdata">
				<div class="logoArea">
					<div class="logo-image">
						<a href="javascript:void(0)" *ngIf="userInfo.has_logo">
							<img src="{{ userInfo.logo }}" alt="logo" loading="lazy">
						</a>
						<p class="simplified-invoice__name" >{{ userInfo.business_name | titlecase }}</p>
					</div>
					<div *ngIf="taxAmount" class="teem-address">{{ userInfo.address }}</div>
					<div class="taxSection" *ngIf="taxAmount">
						<span class="tax-no" *ngIf="userInfo.tax_number">
							<ng-container i18n="@@invoices.preview.tax_no"> TIN : </ng-container> {{ userInfo.tax_number }}
						</span>
					</div>
				</div>
				<div class="priceSection simplified-invoice__headerMetaData">
					<span class="total-due" i18n="@@invoices.preview.total_amount_due" [attr.style]="'color:'+prefTextColor | safe:'style'">TOTAL AMOUNT DUE</span>
					<span class="amount"><span class="sar" [innerHtml]="userInfo.currency_symbol"></span> {{ invoiceTotal | number:'.2' }}</span>
					<div class="simplified-invoice__status simplified-invoice__status--unpaid" i18n="@@ts.unpaid">Unpaid</div>
				</div>
			</div>

			<div class="wrapper">
				<div class="simplified-invoice__mobileaddress">
					{{ userInfo.address }}
				</div>
			</div>

			<div class="wrapper no-wrapper">
				<hr class="hr-row">
			</div>

			<div class="wrapper">
				<div class="taxSection">
					<span class="name">{{ invoiceDetail.client ? invoiceDetail.client.full_name : "Unknown Client" }}</span>
					<!-- <span class="tax-no" *ngIf="userInfo.tax_number">
						<ng-container i18n="@@invoices.preview.tax_no">TIN:</ng-container> {{ userInfo.tax_number }}
					</span> -->
				</div>
				<div class="date-and-no">
					<span class="number" [attr.style]="'color:'+prefTextColor | safe:'style'">#{{ invoiceDetail.invoice_number }}</span>
					<span class="date">{{ invoiceDetail.invoice_date }}</span>
				</div>
			</div>

			<div class="wrapper no-wrapper">
				<hr class="hr-row">
			</div>

			<div class="prev-invoice__tableSection">
				<div class="wrapper">
					<table>
						<thead>
							<tr>
								<th class="item-title" [attr.style]="'color:'+prefTextColor | safe:'style'" i18n="@@invoices.preview.item_cap">ITEM</th>
								<th class="item-amount" [attr.style]="'color:'+prefTextColor | safe:'style'" i18n="@@invoices.preview.amount_cap">AMOUNT</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngIf="invoiceDetail.items && invoiceDetail.items.length; else noItem">
								<tr *ngFor="let deliverable of invoiceDetail.items; index as $index; first as isFirst; last as isLast" [ngClass]="{'dotted-border': isFirst, 'b-dotted-border':isLast && !taxAmount }">
									<td class="item-title"><span class="count-num">{{ deliverable.quantity }} X</span>&rlm;{{ deliverable.title }}</td>
									<td class="item-amount"><span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span> {{ getItemSubTotal(deliverable) | number:'.2' }} </td>
								</tr>
								<tr class="dashed-border" *ngIf="taxAmount">
									<td class="item-title">
										<ng-container i18n="@@tax">VAT</ng-container>({{ invoiceDetail.tax_percent }}%)
									</td>
									<td class="item-amount"><span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span> {{ taxAmount | number:'.2' }} </td>
								</tr>
							</ng-container>
							<ng-template #noItem>
								<tr>
									<td class="text-center" [attr.colspan]="2" i18n="@@invoices.no_deliverable"> No deliverable</td>
								</tr>
							</ng-template>
						</tbody>
					</table>
				</div>
			</div>
			
			<div class="wrapper">
				<div class="prev-invoice__totalSection simplified-invoice__totalSection">
					<ul>
						<li *ngIf="invoiceOriginalAmount != null">
							<span class="totalAmount simplified-invoice__totalSection--black" i18n="@@invoices.total">Total</span>
							<span class="totalRate simplified-invoice__totalSection--black"><span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span> {{ invoiceOriginalAmount | number:'.2' }}</span>
						</li>
						<li *ngIf="invoiceDiscountAmount != null">
							<span class="totalAmount simplified-invoice__totalSection--black" i18n="@@invoices.discount">Discount
								<!-- <ng-container *ngIf="invoiceDetail?.discount_type == 'percentage'; else elseDiscountType">
									({{invoiceForm.controls.discount.value}}<span class="sar-cur">%</span>)
								</ng-container>
								<ng-template #elseDiscountType>
									({{invoiceForm.controls.discount.value | number:'.2' }}<span class="sar-cur">{{ userInfo.currency_symbol }}</span>)
								</ng-template> -->
							</span>
							<span class="totalRate simplified-invoice__totalSection--black"><span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span> {{ invoiceDiscountAmount | number:'.2' }}</span>
						</li>
						<!-- <li *ngIf="invoiceDiscountAmount != null">
							<span class="totalAmount simplified-invoice__totalSection--black" i18n="@@invoices.discount">Discount ({{invoiceForm.controls.discount.value}}%)</span>
							<span class="totalRate simplified-invoice__totalSection--black">{{ invoiceDiscountAmount | number:'.2' }}<span class="sar-cur">{{ userInfo.currency_symbol }}</span></span>
						</li> -->
						<li *ngIf="invoiceDeliveryFeeAmount != null">
							<span class="totalAmount simplified-invoice__totalSection--black" i18n="@@invoices.delivery_fees">Delivery Fees</span>
							<span class="totalRate simplified-invoice__totalSection--black"><span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span> {{ invoiceDeliveryFeeAmount | number:'.2' }}</span>
						</li>
						<li>
							<span class="totalAmount" [attr.style]="'color:'+prefTextColor | safe:'style'" i18n="@@invoices.preview.total_amount_due">Total Amount Due</span>
							<span class="totalRate simplified-invoice__totalSection--black"><span class="sar-cur" [innerHtml]="userInfo.currency_symbol"></span> 
								{{ (invoiceTotal > 0) ? (invoiceTotal | shortNumber) : (invoiceTotal | number:'.2') }}
							</span>
						</li>
					</ul>
				</div>
			</div>

			<!-- <div class="wrapper no-wrapper simplified-invoice__mobileLine">
				<hr class="hr-row simplified-invoice__line">
			</div> -->

			<div class="wrapper d-block">
				<div class="simplified-invoice-additionalInfo">
					<div class="simplified-invoice-additionalInfo__header">
						<p i18n="@@invoices.additional_info" [attr.style]="'color:'+prefTextColor | safe:'style'">ADDITIONAL INFORMATION</p>
						<div></div>
					</div>

					<div class="simplified-invoice-additionalInfo__body">
						<p class="pre-text">{{ defaultAdditionalInfo }}</p>
					</div>

					<div class="simplified-invoice-additionalInfo__actions">
						<div class="simplified-invoice-additionalInfo__qrcode" >
							<ng-container *ngIf="qrCodeBase64 && taxInvoice">
								<qr-code value="{{ qrCodeBase64 }}" size="150" errorCorrectionLevel="M"></qr-code>
							</ng-container>
						</div>
						
						<div class="simplified-invoice-additionalInfo__btnsGroup simplified-invoice-additionalInfo__btnsGroup--web" >
							<div class="simplified-invoice-additionalInfo__btns" *ngIf="showSaveBtn">
								<button class="tu-btn blue select-plan" (click)="saveInvoice()" i18n="@@invoices.save_to_all_invoice">Save to all invoices</button>
								<button class="tu-btn blue select-plan" (click)="saveAsDraft()" i18n="@@invoices.save_as_draft">Save as draft</button>
							</div>
							<div class="simplified-invoice-additionalInfo__btns simplified-invoice-additionalInfo__btns--actions simplified-invoice-additionalInfo__btns--bold" [class.simplified-invoice-additionalInfo__btns--opacity]="showSaveBtn">
								<a href="javascript:void(0)" class="tu-btn pink simplified-invoice__btnOutline iconed" >
									<svg xmlns="http://www.w3.org/2000/svg" width="20" height="26" viewBox="0 0 20 21">
										<g fill="none" fill-rule="evenodd">
											<g fill="#fb4575">
												<g>
													<path d="M7.65 8.35c.467 0 .85.383.85.85v3.4c0 .468-.383.85-.85.85-.468 0-.85-.382-.85-.85V9.2c0-.467.383-.85.85-.85zm5.1 0c.467 0 .85.383.85.85v3.4c0 .468-.383.85-.85.85-.467 0-.85-.382-.85-.85V9.2c0-.467.383-.85.85-.85zm2.55 6.8c0 .468-.38.85-.85.85h-8.5c-.47 0-.85-.382-.85-.85V5.8h10.2v9.35zM8.5 2.679c0-.132.182-.279.425-.279h2.55c.243 0 .425.147.425.279V4.1H8.5V2.679zM17.85 4.1H13.6V2.679C13.6 1.587 12.647.7 11.475.7h-2.55C7.753.7 6.8 1.587 6.8 2.679V4.1H2.55c-.467 0-.85.383-.85.85 0 .468.383.85.85.85h.85v9.35c0 1.406 1.144 2.55 2.55 2.55h8.5c1.406 0 2.55-1.144 2.55-2.55V5.8h.85c.467 0 .85-.382.85-.85 0-.468-.383-.85-.85-.85z" transform="translate(-1308 -823) translate(888 690) translate(32 122) translate(388 8)"/>
												</g>
											</g>
										</g>
									</svg>
								</a>
								<a href="javascript:void(0)" (click)="closeModel()" class="tu-btn green iconed iconed--labeled" >
									<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
										<path fill="#fff" fill-rule="evenodd" d="M16.585 4.283L15.548 5.32 12.68 2.453l1.038-1.037a1.072 1.072 0 0 1 1.512 0l1.355 1.354c.201.201.311.47.311.757 0 .287-.11.555-.31.756zM2.52 12.93l2.55 2.55-2.809.865-.613-.579.872-2.836zm3.49 1.93L3.14 11.991 11.232 3.9l.668-.667L14.768 6.1l-8.76 8.76zM17.364 1.99L16.01.635a2.175 2.175 0 0 0-3.073 0L11.513 2.06l-.003.003-9.727 9.727a.55.55 0 0 0-.137.228l-1.622 5.27a.553.553 0 0 0 .69.689l5.269-1.622a.551.551 0 0 0 .228-.137l.084-.085a.553.553 0 0 0 .207-.206l8.362-8.362 2.501-2.5c.41-.41.635-.955.635-1.537s-.225-1.127-.635-1.537z"/>
									</svg>
									<p i18n="@@button.edit">Edit</p>
								</a>
								<a href="javascript:void(0)" (click)="toggleSaveBtn()" class="tu-btn blue iconed iconed--labeled" >
									<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
										<path d="m17.71 6.29-6-6a1 1 0 0 0-.32-.21A1.09 1.09 0 0 0 11 0H3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V7a1 1 0 0 0-.29-.71zM6 2h4v2H6V2zm6 14H6v-3a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3zm4-1a1 1 0 0 1-1 1h-1v-3a3 3 0 0 0-3-3H7a3 3 0 0 0-3 3v3H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3.41l4 4V15z" fill="#FFF" fill-rule="nonzero"/>
									</svg>
									<p i18n="@@ts.save">Save</p>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="prev-invoice__rightSection">
			
		</div>
	</div>
	
	<div class="prev-invoice__bottomInfo">
		<span i18n="@@invoices.save_and_send__invoice">Save and Send Invoice</span>
		<div>
			<a href="javascript:void(0)" (click)="saveAndWhatsapp()">
				<svg xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 29 29">
					<g fill="none" fill-rule="evenodd">
						<g fill-rule="nonzero">
							<path fill="#EDEDED" d="M0 28.8l1.986-7.2C.696 19.366 0 16.883 0 14.3 0 6.456 6.455 0 14.35 0S28.8 6.455 28.8 14.3c0 7.846-6.554 14.5-14.45 14.5-2.482 0-4.866-.794-7.001-1.986L0 28.8z" transform="translate(-117.000000, -1208.000000) translate(95.000000, 1191.000000) translate(22.000000, 17.000000)"/>
							<path fill="#55CD6C" d="M7.746 24.232l.447.248c1.837 1.142 3.973 1.837 6.207 1.837 6.505 0 11.917-5.412 11.917-12.016S20.905 2.483 14.35 2.483C7.796 2.483 2.483 7.746 2.483 14.3c0 2.284.645 4.518 1.837 6.405l.298.447-1.142 4.171 4.27-1.092z" transform="translate(-117.000000, -1208.000000) translate(95.000000, 1191.000000) translate(22.000000, 17.000000)"/>
							<path fill="#FEFEFE" d="M10.527 7.647l-.944-.05c-.297 0-.595.1-.794.298-.447.397-1.192 1.142-1.39 2.135-.348 1.49.198 3.278 1.49 5.065 1.29 1.788 3.773 4.668 8.143 5.91 1.39.396 2.483.148 3.376-.398.696-.447 1.142-1.142 1.291-1.887l.15-.695c.049-.199-.05-.447-.249-.546l-3.128-1.44c-.199-.1-.447-.05-.596.149l-1.241 1.589c-.1.099-.249.148-.398.099-.844-.298-3.674-1.49-5.214-4.47-.05-.148-.05-.297.05-.396l1.192-1.341c.1-.149.149-.348.1-.497l-1.44-3.227c-.05-.15-.2-.298-.398-.298" transform="translate(-117.000000, -1208.000000) translate(95.000000, 1191.000000) translate(22.000000, 17.000000)"/>
						</g>
					</g>
				</svg>
			</a>
			<a href="javascript:void(0)" (click)="saveAndEmail()" *ngIf="invoiceDetail?.client && invoiceDetail?.client.email" >
				<svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18">
					<g fill="none" fill-rule="evenodd">
						<g fill="#1C6AB6">
							<path d="M17.82 17.144H3.146c-.578 0-1.048-.465-1.048-1.038V5.992l7.757 5.757c.186.14.408.208.629.208.22 0 .442-.069.629-.208l7.757-5.757v10.114c0 .573-.47 1.038-1.048 1.038zm-.699-12.449l-6.638 4.928-6.639-4.928h13.277zm.7-2.074H3.145C1.41 2.62 0 4.017 0 5.733v10.373c0 1.716 1.411 3.112 3.145 3.112H17.82c1.734 0 3.145-1.396 3.145-3.112V5.733c0-1.716-1.411-3.112-3.145-3.112z" transform="translate(-365 -923) translate(0 849) translate(348 55) translate(17 17)"/>         
						</g>
					</g>
				</svg>
			</a>
			<a href="javascript:void(0)" (click)="saveAsPdf()">
				<svg width="29" height="29" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<path d="M226.378 26.314a.973.973 0 0 1 1.37 0 .964.964 0 0 1 0 1.366l-1.37 1.364a3.858 3.858 0 0 0 .263 5.7c1.564 1.303 3.916 1.055 5.358-.383l1.224-1.221a.97.97 0 0 1 1.37 0 .964.964 0 0 1 0 1.365l-1.37 1.365c-2.443 2.435-6.536 2.244-8.718-.574-1.805-2.33-1.439-5.677.648-7.759zm7.818-.961a.96.96 0 1 1 1.359 1.359l-3.844 3.843a.958.958 0 0 1-1.358 0 .96.96 0 0 1 0-1.358zM232.5 20.17c2.097-2.101 5.48-2.48 7.818-.653a5.826 5.826 0 0 1 .55 8.706l-1.367 1.37a.964.964 0 0 1-1.367 0 .97.97 0 0 1 0-1.37l1.367-1.37a3.882 3.882 0 0 0-.262-5.718c-1.563-1.31-3.91-1.06-5.35.383l-1.223 1.226a.964.964 0 0 1-1.367 0c-.377-.378-.381-.988.17-1.54z" id="mqvg4x98ka"/>
					<use stroke="#1C6AB6" stroke-width=".5" fill="#1C6AB6" xlink:href="#mqvg4x98ka" transform="translate(-223 -18)" fill-rule="evenodd"/>
				</svg>
			</a>
		</div>
	</div>
</div>
